function getUnits({ loyaltypoints_name: loyaltypointsName, xp_name: xpName, monthlypoints_name: monthlypointsName }) {
  return {
    loyaltypoints: {
      1: ` ${loyaltypointsName} extra pro 10 min`,
      2: ` ${loyaltypointsName} extra pro 10 min`,
    },
    xp: {
      1: ` ${xpName} extra pro 10 min`,
      2: ` ${xpName} extra pro 10 min`,
    },
    monthlypoints: {
      1: ` ${monthlypointsName} extra pro 10 min`,
      2: ` ${monthlypointsName} extra pro 10 min`,
    },
    bonus_tier1_loyalty: {
      2: ` ${loyaltypointsName} extra pro Sub / Gifted Sub Tier 1`,
    },
    bonus_tier2_loyalty: {
      2: ` ${loyaltypointsName} extra pro Sub / Gifted Sub Tier 2`,
    },
    bonus_tier3_loyalty: {
      2: ` ${loyaltypointsName} extra pro Sub / Gifted Sub Tier 3`,
    },
    bonus_tier1_monthly: {
      2: ` ${monthlypointsName} extra pro Sub / Gifted Sub Tier 1`,
    },
    bonus_tier2_monthly: {
      2: ` ${monthlypointsName} extra pro Sub / Gifted Sub Tier 2`,
    },
    bonus_tier3_monthly: {
      2: ` ${monthlypointsName} extra pro Sub / Gifted Sub Tier 3`,
    },
    bonus_tier1_xp: {
      2: ` ${xpName} extra pro Sub / Gifted Sub Tier 1`,
    },
    bonus_tier2_xp: {
      2: ` ${xpName} extra pro Sub / Gifted Sub Tier 2`,
    },
    bonus_tier3_xp: {
      2: ` ${xpName} extra pro Sub / Gifted Sub Tier 3`,
    },
    luck_loyalty: { 1: ' % Chance', 2: ` ${loyaltypointsName}` },
    double_loyalty: { 1: ` % Chance alle 10 min auf doppelte ${loyaltypointsName}` },
    double_monthly: { 1: ` % Chance alle 10 min auf doppelte ${monthlypointsName}` },
    double_xp: { 1: ` % Chance alle 10 min auf doppelte ${xpName}` },
    double_xp_dono: { 1: ` % Chance auf doppelte ${xpName} bei einer Donation` },
    double_monthly_dono: { 1: ` % Chance auf doppelte ${monthlypointsName} bei einer Donation` },
    double_loyalty_dono: { 1: ` % Chance auf doppelte ${loyaltypointsName} bei einer Donation` },
  };
}

function getUnit(storeState, slug, index) {
  const units = getUnits(storeState);
  return units[slug]?.[index] ?? '';
}

export { getUnits, getUnit };
